import React from "react";
import { Table } from "react-bootstrap";

function UsersTable({ users }) {
  return (
    <Table bordered striped>
      <thead>
        <tr>
          <th>Nome</th>
          <th>E-mail</th>
        </tr>
      </thead>
      <tbody>
        {users.map((user, index) => (
          <tr key={index}>
            <td>{user.name}</td>
            <td>{user.email}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

export default UsersTable;



// WEBPACK FOOTER //
// ./src/components/pages/Users/UsersTable.js